// START_MODULE pages_main_sections_news_styled_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import styled from 'styled-components';

import Button from 'components/atoms/button/Button';

export const NewsInnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;

export const MoreNewsButton = styled(Button)`
  float: right;
  margin-top: 4px;
`;

// END_MODULE pages_main_sections_news_styled_ts
